import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { SupportTicketId } from '../model/support-ticket-id'
import type {
  SupportAdminTicketsListParams,
  SupportAdminTicketsMessagesCreatePayload,
  SupportAdminTicketsMessagesListParams,
  SupportAdminTicketsStatusPartialUpdatePayload,
} from '@blade/trade-api-client'

export const fetchSupportAdminTicketsRequestAction = action(
  async (ctx, req: SupportAdminTicketsListParams) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.support.supportAdminTicketsList, [req]),
    )

    return result
  },
  'fetchSupportAdminTicketsRequestAction',
)

export const fetchSupportAdminTicketsUnreadRequestAction = action(
  async (ctx) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.support.supportAdminTicketsUnreadList, []),
    )

    return result
  },
  'fetchSupportAdminTicketsUnreadRequestAction',
)

export const fetchSupportAdminTicketMessagesRequestAction = action(
  async (ctx, req: SupportAdminTicketsMessagesListParams) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      ctx.schedule(() =>
        apiRequest(
          ctx,
          tradeApiClient.support.supportAdminTicketsMessagesList,
          [req],
        ),
      ),
    )

    return result.pipe(Result.mapError(ApiError.fallbackToUnknown))
  },
  'fetchSupportAdminTicketMessagesRequestAction',
)

export const sendSupportAdminTicketMessageRequestAction = action(
  async (
    ctx,
    {
      ticketId,
      ...req
    }: { ticketId: SupportTicketId } & SupportAdminTicketsMessagesCreatePayload,
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(
        ctx,
        tradeApiClient.support.supportAdminTicketsMessagesCreate,
        [{ ticketId }, req],
      ),
    )

    return result
  },
  'sendSupportAdminTicketMessageRequestAction',
)

export const updateSupportAdminTicketStatusRequestAction = action(
  async (
    ctx,
    {
      ticketId,
      ...req
    }: {
      ticketId: SupportTicketId
    } & SupportAdminTicketsStatusPartialUpdatePayload,
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(
        ctx,
        tradeApiClient.support.supportAdminTicketsStatusPartialUpdate,
        [{ ticketId }, req],
      ),
    )

    return result
  },
  'updateSupportAdminTicketStatusRequestAction',
)
